"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOtpTemplateChannelTypes = void 0;
/**
 * Типы каналов которые возможны у темплейтов
 */
var EOtpTemplateChannelTypes;
(function (EOtpTemplateChannelTypes) {
    EOtpTemplateChannelTypes["sms"] = "sms";
    EOtpTemplateChannelTypes["viber"] = "viber";
    EOtpTemplateChannelTypes["voice"] = "voice";
    EOtpTemplateChannelTypes["vk"] = "vk";
    EOtpTemplateChannelTypes["whatsapp"] = "whatsapp";
    EOtpTemplateChannelTypes["flashcall"] = "flashcall";
})(EOtpTemplateChannelTypes || (exports.EOtpTemplateChannelTypes = EOtpTemplateChannelTypes = {}));
//# sourceMappingURL=OtpTemplateChannelTypes.enum.js.map